export const config = {
  "projectId": `${process.env.GATSBY_PROJECT_ID}`,
  "dataset": `${process.env.GATSBY_DATASET}`
}
